/**
 * Route name definitions matching SearchPage's RoutingDefinitions class
 * Route names follow the parameter order in the path (left to right)
 */
export enum RoutingDefinitions {
	ROOT = 'Root',
	PORTAL_ROUTE = 'Portal',
	PORTAL_OMNISEARCH_ROUTE = 'PortalOmniSearch',
	DISCIPLINE_DEGREE_TYPE_ROUTE = 'DisciplineDegreeType',
	DISCIPLINE_ATTENDANCE_ROUTE = 'DisciplineAttendance',
	DISCIPLINE_DURATION_ROUTE = 'DisciplineDuration',
	DISCIPLINE_DENSITY_ROUTE = 'DisciplineDensity',
	DISCIPLINE_TUITION_FEE_ROUTE = 'DisciplineTuitionFee',
	DISCIPLINE_TUITION_FEE_ATTENDANCE_ROUTE = 'DisciplineTuitionFeeAttendance',
	DISCIPLINE_ROUTE = 'Discipline',
	DISCIPLINE_COUNTRY_ROUTE = 'DisciplineCountry',
	DISCIPLINE_EDUCATIONAL_FORM_ROUTE = 'DisciplineEducationalForm',
	DISCIPLINE_EDUCATIONAL_FORM_COUNTRY_ROUTE = 'DisciplineEducationalFormCountry',
	COUNTRY_DISCIPLINE_ROUTE = 'CountryDiscipline',
	DISCIPLINE_COUNTRY_AREA_ROUTE = 'DisciplineCountryArea',
	DISCIPLINE_AREA_ROUTE = 'DisciplineArea',
	DISCIPLINE_CONTINENT_ROUTE = 'DisciplineContinent',
	DISCIPLINE_DEGREE_TYPE_COUNTRY_ROUTE = 'DisciplineDegreeTypeCountry',
	DISCIPLINE_DURATION_ATTENDANCE_ROUTE = 'DisciplineDurationAttendance',
	COUNTRY_ROUTE = 'Country',
	AREA_ROUTE = 'Area',
	CONTINENT_ROUTE = 'Continent',
	DEGREE_ROUTE = 'Degree',
	COUNTRY_DEGREE_TYPE_ROUTE = 'CountryDegreeType',
	COUNTRY_ATTENDANCE_DEGREE_TYPE_ROUTE = 'CountryAttendanceDegreeType',
	COUNTRY_DEGREE_TYPE_DURATION_ROUTE = 'CountryDegreeTypeDuration',
	COUNTRY_DURATION_ROUTE = 'CountryDuration',
	COUNTRY_ATTENDANCE_ROUTE = 'CountryAttendance',
	COUNTRY_DENSITY_ROUTE = 'CountryDensity',
	COUNTRY_TUITION_FEE_ROUTE = 'CountryTuitionFee',
	COUNTRY_AREA_ROUTE = 'CountryArea',
	COUNTRY_EDUCATIONAL_FORM_ROUTE = 'CountryEducationalForm',
	ERROR = 'Error',
	ATTENDANCE_ROUTE = 'Attendance',
	ATTENDANCE_DEGREE_TYPE_ROUTE = 'AttendanceDegreeType',
	ATTENDANCE_AREA_ROUTE = 'AttendanceArea',
	ATTENDANCE_COUNTRY_AREA_ROUTE = 'AttendanceCountryArea',
	SPECIAL_PROGRAMMES_ROUTE = 'SpecialProgrammes',
	TUITION_FEE_ROUTE = 'TuitionFee',
	TUITION_FEE_CONTINENT_ROUTE = 'TuitionFeeContinentRoute',
	DEGREE_TYPE_ATTENDANCE_DISCIPLINE_ROUTE = 'DegreeTypeAttendanceDiscipline',
	DEGREE_TYPE_COUNTRY_TUITION_FEE_ROUTE = 'DegreeTypeCountryTuitionFee',
	DEGREE_TYPE_COUNTRY_ATTENDANCE_ROUTE = 'DegreeTypeCountryAttendance',
	DENSITY_ROUTE = 'Density',
	DEGREE_TYPE_DENSITY_ROUTE = 'DegreeTypeDensity',
	DEGREE_TYPE_TUITION_FEE_ATTENDANCE_ROUTE = 'DegreeTypeTuitionFeeAttendance',
	DEGREE_TYPE_AREA_ROUTE = 'DegreeTypeArea',
	DEGREE_TYPE_TUITION_FEE_ROUTE = 'DegreeTypeTuitionFee',
	DEGREE_TYPE_CONTINENT_ROUTE = 'DegreeTypeContinent',
	TUITION_FEE_ATTENDANCE_ROUTE = 'TuitionFeeAttendance',
	DURATION_ROUTE = 'Duration',
	ATTENDANCE_DURATION_ROUTE = 'AttendanceDuration',
	DEGREE_TUITION_FEE_AREA_ROUTE = 'DegreeTuitionFeeArea',
	ATTENDANCE_DISCIPLINE_CONTINENT_ROUTE = 'AttendanceDisciplineContinent',
	DEGREE_TYPE_TUITION_FEE_CONTINENT_ROUTE = 'DegreeTypeTuitionFeeContinent',
	DENSITY_ATTENDANCE_ROUTE = 'DensityAttendance',
	ATTENDANCE_CONTINENT_ROUTE = 'AttendanceContinent',
	DENSITY_CONTINENT_ROUTE = 'DensityContinentRoute',
	DEGREE_TYPE_DURATION_ROUTE = 'DegreeTypeDuration',
	DEGREE_TYPE_COUNTRY_ROUTE = 'DegreeTypeCountry',
	DEGREE_TYPE_DISCIPLINE_ROUTE = 'DegreeTypeDiscipline',
	SPECIAL_PROGRAMMES_CONTINENT_ROUTE = 'SpecialProgrammesContinent',
	SPECIAL_PROGRAMMES_COUNTRY_ROUTE = 'SpecialProgrammesCountry',
	DURATION_AREA_ROUTE = 'DurationArea',
	DENSITY_AREA_ROUTE = 'DensityArea',
	DENSITY_DISCIPLINE_AREA_ROUTE = 'DensityDisciplineArea',
	DEGREE_TYPE_TUITION_FEE_DENSITY_ROUTE = 'DegreeTypeTuitionFeeDensity',
	DURATION_CONTINENT_ROUTE = 'DurationContinent',
	SPECIAL_PROGRAMMES_DISCIPLINE_ROUTE = 'SpecialProgrammesDiscipline',
	DEGREE_TYPE_DENSITY_ATTENDANCE_ROUTE = 'DegreeTypeDensityAttendance',
	ATTENDANCE_DISCIPLINE_COUNTRY_ROUTE = 'AttendanceDisciplineCountry',
	DENSITY_DISCIPLINE_COUNTRY_ROUTE = 'DensityDisciplineCountry',
	DENSITY_DISCIPLINE_DURATION = 'DensityDisciplineDuration',
	DENSITY_DISCIPLINE_CONTINENT_ROUTE = 'DensityDisciplineContinent',
	DISCIPLINE_DURATION_DENSITY_ROUTE = 'DisciplineDensityDuration',
	DEGREE_TYPE_SPECIAL_PROGRAMMES_ROUTE = 'DegreeTypeSpecialProgrammes',
	DEGREE_TYPE_SPECIAL_PROGRAMMES_ATTENDANCE_ROUTE = 'DegreeTypeSpecialProgrammesAttendance',
	DEGREE_TYPE_DISCIPLINE_CONTINENT_ROUTE ='DegreeTypeDisciplineContinent',
	DEGREE_TYPE_DISCIPLINE_COUNTRY_ROUTE ='DegreeTypeDisciplineCountry',
	DEGREE_TYPE_DISCIPLINE_DURATION_ROUTE ='DegreeTypeDisciplineDuration',
	CATCH_ALL = 'CatchAll',
}
